export default __webpack_public_path__ + "static/media/contact.814e5c18.webp";